export default {
  title: 'Panoramica azienda',
  description: 'Bentornato, {{name}}! Ecco cosa sta succedendo con il tuo marketing.',
};
